exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* Remove the drawers toggle button from AppLayout */\n.lineage-v2-container [class*=\"drawers-trigger\"]{\n  display: none !important;\n}\n", ""]);

